export const BREADCRUMB = {
	LIST: 'BREADCRUMB/LIST',
}
export const USER = {
	LOGIN: 'USER/LOGIN',
	LOGOUT: 'USER/LOGOUT',
	UPDATE: 'USER/UPDATE',
}

export const ACCOUNT = {
	LIST: 'ACCOUNT/LIST',
	DELETE: 'ACCOUNT/DELETE',
	CREATE: 'ACCOUNT/CREATE',
	CURRENT: 'ACCOUNT/BY_ID',
	CHANGE_TYPE: 'ACCOUNT/CHANGE_TYPE',
	TOP_FOLLOWERS: 'ACCOUNT/TOP_FOLLOWERS',
	TOP_ENGAGEMENT: 'ACCOUNT/TOP_ENGAGEMENT',
	UPDATE: 'ACCOUNT/UPDATE',
	REMOVE_GROUP: 'ACCOUNT/REMOVE_GROUP',
	TYPE_COUNT: 'ACCOUNT/TYPE_COUNT',
}

export const ACCOUNT_TYPE = {
	LIST: 'ACCOUNT_TYPE/LIST',
}

export const DETAIL = {
	LIST: 'DETAIL/LIST',
	BY_ID: 'DETAIL/BY_ID',
	ADD: 'DETAIL/ADD',
	DISABLE: 'DETAIL/DISABLE',
	DELETE: 'DETAIL/DELETE',
	EVOLUTION_POST: 'EVOLUTION/EVOLUTION_POST',
	ACTIVITY: 'DETAIL/ACTIVITY',
}

export const NETWORK = {
	LIST: 'NETWORK/LIST',
}

export const POST = {
	LIST: 'POST/LIST',
	ADD_LIST: 'POST/ADD_LIST',
	COUNT: 'POST/COUNT',
	UPDATE_IMAGE: 'POST/UPDATE_IMAGE',
	CURRENT: 'POST/CURRENT',
	RECENT: 'POST/RECENT',
	TOP: 'POST/TOP',
}

export const POST_CATEGORY = {
	UPDATE: 'POST_CATEGORY/UPDATE',
}

export const POST_OCR_LOGO = {
	LIST: 'POST_OCR_LOGO/LIST',
	ADD_LIST: 'POST_OCR_LOGO/ADD_LIST',
	COUNT: 'POST_OCR_LOGO/COUNT',
	RECENT: 'POST_OCR_LOGO/RECENT',
}

export const STORIES = {
	LIST: 'STORIES/LIST',
	ADD_LIST: 'STORIES/ADD_LIST',
	COUNT: 'STORIES/COUNT',
}

export const CATEGORY = {
	LIST: 'CATEGORY/LIST',
	DELETE: 'CATEGORY/DELETE',
	CREATE: 'CATEGORY/CREATE',
}
export const INFLUENCERS = {
	LIST: 'INFLUENCERS/LIST',
}
export const COMMENT = {
	LIST: 'COMMENT/LIST',
	ANALYSIS: 'COMMENT/ANALYSIS',
	EXPAND: 'COMMENT/EXPAND',
	HIDE: 'COMMENT/HIDE',
}

export const ANALYSIS = {
	CONTENT_SENTIMENT: 'ANALYSIS/CONTENT_SENTIMENT',
	IMAGE_EXPRESSION: 'ANALYSIS/IMAGE_EXPRESSION',
	IMAGE_LABELS: 'ANALYSIS/IMAGE_LABELS',
	IMAGE_OCR: 'ANALYSIS/IMAGE_OCR',
	HASHTAG_SENTIMENT: 'ANALYSIS/HASHTAG_SENTIMENT',
	HASHTAG_CLASSIFY: 'ANALYSIS/HASHTAG_CLASSIFY',
	HASHTAG_ENTITY: 'ANALYSIS/HASHTAG_ENTITY',
	HASHTAG: 'ANALYSIS/HASHTAG',
	IMAGE: 'ANALYSIS/IMAGE',
}

export const DASHBOARD = {
	INTERACTIONS: 'DASHBOARD/INTERACTIONS',
	FOLLOWERS: 'DASHBOARD/FOLLOWERS',
	SHARE: 'DASHBOARD/SHARE',
	STATS: 'DASHBOARD/STATS',
	STATS_USER: 'DASHBOARD/STATS_USER',
}

export const ACCOUNT_GROUP = {
	CREATE: 'ACCOUNT_GROUP/CREATE',
	LIST: 'ACCOUNT_GROUP/LIST',
	DELETE: 'ACCOUNT_GROUP/DELETE',
}

export const INTERACTION = {
	SHARE: 'INTERACTION/SHARE',
}
